<template>
  <div class="toggle">
    <button v-on:click="onSwitch" class="toggle__btn" ref="buttonEl">
      <span
        class="toggle__switch"
        :style="switchInlineStyle"
      ></span>
      <div class="toggle__switch-text-container">
        <span class="toggle__switch-text" ref="optionOneEl" v-html="optionOne"></span>
        <span class="toggle__switch-text" ref="optionTwoEl" v-html="optionTwo"></span>
      </div>
    </button>
  </div>
</template>
<script>
export default {
  name: "ToggleSwitch",
  props: ["optionOne", "optionTwo", "onSwitch", "value"],
  data() {
    return {
      optionOneWidth: 0,
      optionTwoWidth: 0,
      optionOneLeft: 0,
      optionTwoLeft: 0,
      insetPaddingPx: 0,
    };
  },
  computed: {
    isSecondSelected() {
      return this.value === this.optionTwo;
    },
    switchWidthPx() {
      return this.isSecondSelected ? this.optionTwoWidth : this.optionOneWidth;
    },
    switchLeftPx() {
      const left = this.isSecondSelected ? this.optionTwoLeft : this.optionOneLeft;
      return left + this.insetPaddingPx;
    },
    switchInlineStyle() {
      return {
        width: this.switchWidthPx + "px",
        left: this.switchLeftPx + "px",
      };
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.measurePositions();
      window.addEventListener("resize", this.handleResize, { passive: true });
    });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  watch: {
    value() {
      this.$nextTick(this.measurePositions);
    },
    optionOne() {
      this.$nextTick(this.measurePositions);
    },
    optionTwo() {
      this.$nextTick(this.measurePositions);
    },
  },
  methods: {
    handleResize() {
      this.measurePositions();
    },
    measurePositions() {
      const optionOneEl = this.$refs.optionOneEl;
      const optionTwoEl = this.$refs.optionTwoEl;
      const buttonEl = this.$refs.buttonEl;

      if (optionOneEl && optionTwoEl && buttonEl) {
        const oneRect = optionOneEl.getBoundingClientRect();
        const twoRect = optionTwoEl.getBoundingClientRect();
        const btnRect = buttonEl.getBoundingClientRect();

        this.optionOneWidth = Math.round(oneRect.width);
        this.optionTwoWidth = Math.round(twoRect.width);
        this.optionOneLeft = Math.round(oneRect.left - btnRect.left);
        this.optionTwoLeft = Math.round(twoRect.left - btnRect.left);
      } else {
        this.optionOneWidth = optionOneEl ? optionOneEl.offsetWidth : 0;
        this.optionTwoWidth = optionTwoEl ? optionTwoEl.offsetWidth : 0;
        this.optionOneLeft = optionOneEl ? optionOneEl.offsetLeft : 0;
        this.optionTwoLeft = optionTwoEl ? optionTwoEl.offsetLeft : 0;
      }
    },
  },
};
</script>
